(function () {
    'use strict';

    angular
        .module('app.shared')
        .component('sc3ChangePasswordModal', {
            templateUrl: 'app/shared/user-settings/change-password-modal.component.html',
            bindings: { 
                close: '&', 
                dismiss: '&',
                modalInstance: '<',
                resolve: '<' 
            },
            controller: ChangePasswordModalComponent,
        });

    ChangePasswordModalComponent.$inject = ['Member', 'passwordOptions', 'alert', 'shared_resources', '$state'];
    function ChangePasswordModalComponent(Member, options, alert, resources, $state) {
        // properties
        var ctrl = this;
        ctrl.passwordRequiredLength = options.requiredLength;

        // methods
        ctrl.$onInit = init;
        ctrl.submit = submit;
        ctrl.validatePasswordMatch = validatePasswordMatch;
        ctrl.validatePasswordTooShort = validatePasswordTooShort;
        ctrl.validatePasswordRequiresNonAlphanumeric = validatePasswordRequiresNonAlphanumeric;
        ctrl.validatePasswordRequiresDigit = validatePasswordRequiresDigit;
        ctrl.validatePasswordRequiresLower = validatePasswordRequiresLower;
        ctrl.validatePasswordRequiresUpper = validatePasswordRequiresUpper;
        ctrl.validateOldPassword = validateOldPassword;
        Object.defineProperty(ctrl, 'isAdminPage', { get: getIsAdminPage });

        /////////////////////////////////////////
        function init(){
            ctrl.settings = ctrl.resolve.model || {};
        }
        function submit() {
            if (ctrl.form.$valid) {
                Member.changePassword({ id: ctrl.settings.individualId }, ctrl.settings, success, error, true);
            }

            function success() {
                ctrl.close();
                ctrl.modalInstance.result.then(showSucceededMessage);

                function showSucceededMessage() {
                    alert.success(resources.changePasswordSucceeded);
                }
            }
            function error(error) {
                if (error && error.status === 400 && 'OldPassword' in error.data) {
                    ctrl.form.oldPassword.$setValidity('invalid', false);
                }
                else {
                    alert.error(resources.changePasswordFailed);
                }
            }
        }

        function validatePasswordMatch(value) {
            var verification = ctrl.settings.verification;
            return !value || !verification || verification === value;
        }
        function validatePasswordTooShort(value) {
            return !value || value.length >= options.requiredLength;
        }
        function validatePasswordRequiresNonAlphanumeric(value) {
            return !value || !options.requireNonAlphanumeric || rNonAlphanumeric.test(value);
        }
        function validatePasswordRequiresDigit(value) {
            return !value || !options.requireDigit || rDigit.test(value);
        }
        function validatePasswordRequiresLower(value) {
            return !value || !options.requireLowercase || rLowerCase.test(value);
        }
        function validatePasswordRequiresUpper(value) {
            return !value || !options.requireUppercase || rUpperCase.test(value);
        }
        function validateOldPassword(value) {
            // Always set to true.  This will erase the "invalid" error that is only set after a form submit with a special error response if they press
            // any key.
            return true; 
        }
        function getIsAdminPage() {
            var data = $state.$current.data;
            return data && data.requireAdmin;
        }
    }

})();